<template>
	<transition name="el-fade-in-linear">
    <div v-show="transitionshow">       
       	<!----------- 所有销售出库订单查询 -------------->
    	<el-form :inline="true" class="backborder1 demo-form-inline" size="small">
    		<el-form-item size="small">
    			<el-date-picker v-model="order.date" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" @change="orderisselect=true" style="width:100%" :unlink-panels="false"></el-date-picker>
    		</el-form-item>
    		<el-form-item size="small">
    			<el-select v-model="order.customerid" clearable filterable remote reserve-keyword :remote-method="getCustomer" :loading="customerLoading" placeholder="客户名称 / 简称 / 客户手机" @change="orderisselect=true" style="width:100%">
		          	<el-option v-for="(item,index) in customerLists" :key="index" :label="item.showname" :value="item.id"></el-option>
		        </el-select> 
    		</el-form-item>
    		<el-form-item size="small">
    			<el-select v-model="order.account" clearable filterable placeholder="请选支付方式" @change="orderisselect=true" style="width:100%">
					<el-option v-for="(item,index) in accountLists" :key="index" :label="item.name" value="a0" v-if="item.id==0" ></el-option>
					<el-option v-for="(item,index) in accountLists" :key="index" :label="item.name" :value="item.id" v-if="item.id!=''"></el-option>
				</el-select>
    		</el-form-item>
    		<el-form-item size="small">
    			<el-select v-model="order.seller" clearable filterable placeholder="请选销售员" @change="orderisselect=true" style="width:100%">
					<el-option v-for="(item,index) in sellerLists" :key="index" :label="item.name" :value="item.id"></el-option>
				</el-select>
    		</el-form-item>
    		<el-form-item size="small">
    			<el-select v-model="order.status" clearable filterable placeholder="请选状态" @change="orderisselect=true" style="width:100%">
					<el-option v-for="(item,index) in orderstatus" :key="index" :label="item.name" value="a0" v-if="item.id==0"></el-option>
					<el-option v-for="(item,index) in orderstatus" :key="index" :label="item.name" :value="item.id" v-if="item.id!=0"></el-option>
				</el-select>
    		</el-form-item>
    		<el-form-item size="small">
    			<el-select v-model="order.ordertype" clearable filterable placeholder="请选择订单出处" @change="changeordertype" style="width:100%">
    				<el-option v-for="(item,index) in ordertype" :key="index" :label="item.name" value="a0" v-if="item.id==0"></el-option>
					<el-option v-for="(item,index) in ordertype" :key="index" :label="item.name" :value="item.id" v-if="item.id > 0"></el-option>
				</el-select>
    		</el-form-item>
			<el-form-item size="small" v-if="(order.ordertype==1 || order.ordertype==4) && sourceagents.length > 0">
    			<el-select v-model="order.sourceagentid" clearable filterable placeholder="请选择代理商来源" @change="orderisselect=true" style="width:100%">
    				<el-option v-for="(item,index) in sourceagents" :key="index" :label="item.agentname" :value="item.id"></el-option>
				</el-select>
    		</el-form-item>
			<el-form-item size="small">
    			<el-select v-model="order.keytype" filterable placeholder="关键字搜索方式" @change="orderisselect=true" style="width:100%">
    				<el-option v-for="(item,index) in keytypelists" :key="index" :label="item.name" :value="item.id"></el-option>
				</el-select>
    		</el-form-item>
    		<el-form-item size="small" @change="orderisselect=true">
    			<el-input placeholder="请输入订单号" v-model="order.key" ></el-input>
    		</el-form-item>
    		<el-form-item size="small">
    			<el-button type="warning" size="small" icon="el-icon-search" round @click="getOrderlists">搜索</el-button>
    			<el-button type="warning" size="small" icon="el-icon-plus" @click="addnews" :loading="orderaddLoading" v-if="actionauth.order_add=='true'" round>新增销售订单</el-button>
    		</el-form-item>
    	</el-form>
    	
    	<!-- <el-tag type="danger" size="medium" closable @close="tagclose='false'"  v-if="tagclose=='true'" style="margin-top:10px">温馨提示：创始人用户信息不能删除，且其手机号码、用户分类不能编辑</el-tag> -->
    	
    	<div class="backborder2" style="margin-top:10px">
	    	<el-table :data="orderlists" v-loading="orderListLoading">
	    		<el-table-column type="expand">
		            <template slot-scope="props">
						<div style="padding:10px 0;">
		                <div style="width:100%;color:#606266;line-height:23px;font-size:12px">
		                	<span v-if="props.row.contactname!=''">收货人：{{props.row.contactname}}，{{props.row.phone}}，{{props.row.address}}</span>
		                	<span v-if="props.row.shippingcode!='' && props.row.shippingcode!=null ">物流单号：{{props.row.shippingcode}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
		                </div>
						<div style="width:100%;color:#606266;line-height:23px;font-size:12px" v-if="props.row.note!=''">
		                	<span v-if="props.row.note!=''">备注：{{props.row.note}}{{ props.row.ordernumber ? `（商城单号：${props.row.ordernumber}）` : '' }}</span>
		                </div>
						</div>
		                <el-table :data="props.row.goods">
			                <el-table-column label="商品名称" min-width="250">
								<template slot-scope="gprops">
									<span style="float:left;width:100%;font-size:13px;">{{gprops.row.name}}</span>
									<span style="float:left;width:100%;font-size:12px;color:#999999">编号：{{gprops.row.number}}</span>
								</template>
							</el-table-column>
							<el-table-column prop="sell" label="单价" min-width="100" align="center"></el-table-column>
			                <el-table-column prop="discount" label="折扣（%）" min-width="100" align="center"></el-table-column>
			                <el-table-column prop="dis_sell" label="折后单价" min-width="100" align="center"></el-table-column>
							<el-table-column label="数量" min-width="100" align="center">
								<template slot-scope="nprops">
									<span style="float:left;width:100%">{{nprops.row.num}} {{nprops.row.unit}}</span>
								</template>
							</el-table-column>
			                <el-table-column prop="total" label="小计" min-width="100" align="center"></el-table-column>
			                <el-table-column prop="type" label="类型" min-width="100" align="center">
								<template slot-scope="nprops">
									<span style="float:left;width:100%;font-size:13px;text-align:center;">{{nprops.row.type}}</span>
								</template>
							</el-table-column>
		                </el-table>
		            </template>
	            </el-table-column>

				<el-table-column label="id" prop="id" align="center" min-width="90"></el-table-column>
		        <el-table-column label="订单信息" prop="documents" min-width="250">
					<template slot-scope="scope">
						<span v-if="scope.row.paytype==0">{{scope.row.documents}}</span>
						<div class="sell-type-main" v-if="scope.row.paytype==1">
							<span style="float:left">{{scope.row.documents}}</span>
							<el-tooltip class="item" effect="dark" content="线上商城订单" placement="top-start">
							<div class="sell-type-icon"><img src="../../assets/sellicon/sell_shop.png"></div>
							</el-tooltip>
						</div>
						<div class="sell-type-main" v-if="scope.row.paytype==3">
							<span style="float:left">{{scope.row.documents}}</span>
							<el-tooltip class="item" effect="dark" content="跑店订单" placement="top-start">
							<div class="sell-type-icon"><img src="../../assets/sellicon/sell_run.png"></div>
							</el-tooltip>
						</div>
						<div class="sell-type-main" v-if="scope.row.paytype==4">
							<span style="float:left">{{scope.row.documents}}</span>
							<el-tooltip class="item" effect="dark" content="抽奖订单" placement="top-start">
							<div class="sell-type-icon"><img src="../../assets/sellicon/sell_fenxiao.png"></div>
							</el-tooltip>
						</div>
						<div class="sell-type-main" v-if="scope.row.paytype==5">
							<span style="float:left">{{scope.row.documents}}</span>
							<el-tooltip class="item" effect="dark" content="分销订单" placement="top-start">
							<div class="sell-type-icon"><img src="../../assets/sellicon/sell_fenxiao.png"></div>
							</el-tooltip>
						</div>
						<div class="sell-type-main" v-if="scope.row.paytype==6">
							<span style="float:left">{{scope.row.documents}}</span>
							<el-tooltip class="item" effect="dark" content="邀请有礼订单" placement="top-start">
							<div class="sell-type-icon"><img src="../../assets/sellicon/sell_fenxiao.png"></div>
							</el-tooltip>
						</div>
						<div class="sell-type-main" v-if="scope.row.paytype==7">
							<span style="float:left">{{scope.row.documents}}</span>
							<el-tooltip class="item" effect="dark" content="抖音订单" placement="top-start">
							<div class="sell-type-icon"><img src="../../assets/sellicon/sell_dshop.png"></div>
							</el-tooltip>
						</div>
						<div class="sell-type-main" v-if="scope.row.paytype==8">
							<span style="float:left">{{scope.row.documents}}</span>
							<el-tooltip class="item" effect="dark" content="天猫订单" placement="top-start">
							<div class="sell-type-icon"><img src="../../assets/sellicon/sell_tmall.png"></div>
							</el-tooltip>
						</div>
						<div class="sell-type-main" v-if="scope.row.paytype==9">
							<span style="float:left">{{scope.row.documents}}</span>
							<el-tooltip class="item" effect="dark" content="拼多多订单" placement="top-start">
							<div class="sell-type-icon"><img src="../../assets/sellicon/sell_pindd.png"></div>
							</el-tooltip>
						</div>
						<span style="float:left;width:100%;font-size:.7rem;color:#909399">客户：{{scope.row.customername}}</span>
						<span style="float:left;width:100%;font-size:.7rem;color:#909399">销售员：{{scope.row.clerkname}}</span>
					</template>
				</el-table-column>

		        <el-table-column label="订单总价" prop="total" align="center" min-width="110"></el-table-column>
		        <el-table-column label="邮费" prop="express" align="center" min-width="110"></el-table-column>
		        <el-table-column label="优惠金额" prop="derate" align="center" min-width="110"></el-table-column>
		        <el-table-column label="应付金额" prop="real" align="center" min-width="110"></el-table-column>
				<el-table-column label="订单时间" prop="inputtime" align="center" min-width="120"></el-table-column>
				<el-table-column label="状态" min-width="140" align="center">
		        	<template slot-scope="scope">
		        		<span style="float:left;width:100%;font-size:13px" v-if="scope.row.status==0">未审核，{{scope.row.accountname}}</span>
		        		<span style="float:left;width:100%;font-size:13px" v-if="scope.row.status==1">已审核，{{scope.row.accountname}}</span>
		        		<span style="float:left;width:100%;font-size:13px" v-if="scope.row.status==2">已完成，{{scope.row.accountname}}</span>
		        		<span style="float:left;width:100%;font-size:13px" v-if="scope.row.status==3">已撤销，{{scope.row.accountname}}</span>
		        	</template>
		        </el-table-column>
		        <el-table-column label="操作" align="center" min-width="260" fixed="right">
		        	<template slot-scope="scope">
		        		<el-button type="warning" size="small" round @click="showorder(scope.row)">查看销售订单</el-button>
						<el-button type="warning" size="small" round  @click="editorder(scope.row)" v-if="scope.row.status==0 && actionauth.order_edit=='true'">编辑</el-button>
						<el-button type="" size="small" @click="listsdelorder(scope.row)" v-if="scope.row.status==0 && actionauth.order_del=='true'" round>删除</el-button>
					</template>
		        </el-table-column>
	      	</el-table>
	      	<div class="block">
	        	<!--分页begin-->
	            <el-pagination
		            @size-change="orderPageSizeChange"
		            @current-change="orderPageCurrentChange"
		            :current-page="order.p"
		            :page-sizes="[10, 20, 50]"
		            :page-size="order.rollpage"
		            layout="total, sizes, prev, pager, next, jumper"
		            :total="total_order_rows">
	            </el-pagination>
	            <!--分页end-->
	      	</div>
    	</div>
    	
    	
  	    
      
      <!---------------------------修改单位--------------------------->
    	<el-dialog title="单位选择" :visible.sync="unitDialog">
      		<el-table :data="unitlists" style="width: 100%" v-loading="unitListLoading">
	        	<el-table-column label="单位" prop="unit"></el-table-column>
	        	<el-table-column label="售价" prop="sell"></el-table-column>
	        	<el-table-column label="市场价" prop="market"></el-table-column>
	        	<el-table-column label="选择" width="80">
		            <template slot-scope="scope">
		            	<el-button type="primary" size="small" circle icon="el-icon-check"  @click="changeUnitSave(scope.row)"></el-button>
		            </template>
	        	</el-table-column>
      		</el-table>
    	</el-dialog>
  		<!--------------------------------修改单位end--------------------------->

  		<!---------------------------修改仓库--------------------------->
    	<el-dialog title="仓库选择" :visible.sync="wareDialog" width="40%">
      		<el-table :data="wareHouseLists" style="width: 100%" v-loading="wareListLoading">
        		<el-table-column label="仓库名称" prop="name"></el-table-column>
        		<el-table-column label="选择" width="80">
          			<template slot-scope="scope">
            			<el-button type="primary" size="small" circle icon="el-icon-check"  @click="changeWareSave(scope.row)"></el-button>
          			</template>
        		</el-table-column>
      		</el-table>
    	</el-dialog>
  		<!--------------------------------修改单位end--------------------------->

  		<!---------------------------修改类型--------------------------->
    	<el-dialog title="类型选择" :visible.sync="typeDialog" width="40%">
      		<el-table :data="typearr" style="width: 100%" v-loading="wareListLoading">
	        	<el-table-column label="类型名称" prop="name"></el-table-column>
	        	<el-table-column label="选择" width="80">
		          	<template slot-scope="scope">
		            	<el-button type="primary" size="small" circle icon="el-icon-check"  @click="changeTypeSave(scope.row)"></el-button>
		          	</template>
	        	</el-table-column>
      		</el-table>
    	</el-dialog>
  		<!--------------------------------修改单位end--------------------------->
		
		<!-----------------------------已选中商品列表------------------------------->
		<div id="showselectgoods" :style="{display:addDialog ? 'block' : 'none'}">
			<span id="selecttitle">已选产品</span>
			<div id="selectdata">
				<el-table :data="multipleSelection">
		            <el-table-column prop="name" label="名称"></el-table-column>
		            <el-table-column label="操作" width="80" align="center">
		          	    <template slot-scope="scope">
		          	  	    <el-button type="danger" size="small" icon="el-icon-delete" circle  @click="delmultipleSelection(scope.row,scope.$index)"></el-button>
		          	    </template>
		          	</el-table-column>
		      	</el-table>
	      	</div>
	      	<div slot="footer" class="dialog-footer"></div>
		</div>
		
  		<!---------------------------批量添加--------------------------->
  		<el-dialog title="添加产品" :visible.sync="addDialog" width="80%" top="1vh">
  		    <el-tag type="danger">温馨提示：1、如需设置默认发货仓库请前往系统设置->用户管理，编辑具体的用户选择默认发货仓库。2、鼠标双击可以直接将点击的单个商品直接添加进入购物车。</el-tag>  		
      		<!------------------------search---------------------->
      		<el-form :inline="true" class="demo-form-inline" size="medium" style="margin-top:15px">
	          	<el-form-item style="width:15%">
		            <el-select v-model="productquery.brandid" filterable clearable placeholder="按品牌"  @change="selectbrand">
		              <el-option v-for="(item,index) in brandlists" :label="item.name" :value="item.id" :key="index"></el-option>
		            </el-select>
	          	</el-form-item>
	          	<el-form-item style="width:15%">
	                <el-cascader :options="categorylist" clearable v-model="productquery.catid" placeholder="请选择分类" @change="selectcate"></el-cascader>
	          	</el-form-item>
	            <el-form-item style="width:15%;">
		            <el-select v-model="productquery.warehouse" clearable placeholder="请选择仓库" @change="selectwarehouse">
		                <el-option v-for="(item,index) in wareHouseLists" :label="item.name" :value="item.id" :key="index"></el-option>
		            </el-select>
	          	</el-form-item>
	          	<el-form-item ref="productquery" :model="productquery" style="width:19%">
	            	<el-input placeholder="商品名称 / 条形码 / 编号 / 拼音码" clearable v-model="productquery.key" @keyup.enter.native="getProductList" @change="isnewselect=true" @input="changesearchkey"></el-input>
	          	</el-form-item>
	          	<el-form-item>
	            	<el-button type="primary" icon="el-icon-search" @click="getProductList">查询</el-button>
	            	<el-button type="danger" icon="el-icon-delete" @click="cleargoods">清空勾选</el-button>
	          	</el-form-item>
        	</el-form>        	
        	
      		<!------------------------search end---------------------->
	      	<el-table ref="multipleTable" :data="productlists" style="width: 100%" v-loading="addListLoading" tooltip-effect="dark" @row-dblclick="rowclick" @row-click="rowclick" @select="handleSelectsingle"  @select-all="handleSelectall"  >
	            <el-table-column type="selection" width="40"></el-table-column>
	            <el-table-column prop="number" label="编号" width="80"></el-table-column>
	            <el-table-column prop="brandname" label="品牌名称" width="100"></el-table-column>
	            <el-table-column prop="name" label="名称"></el-table-column>
	            <el-table-column prop="spec" label="规格" width="120"></el-table-column>
	            <el-table-column prop="housename" label="仓库" width="120"></el-table-column>
	            <el-table-column prop="showsell" label="售价" width="140"></el-table-column>
	            <el-table-column label="库存" width="110">
	          	    <template slot-scope="scope">
	          	  	    <span v-if="scope.row.inventory==0" style="color:#F56C6C">{{scope.row.inventory}}</span>
	          	  	    <span v-if="scope.row.inventory>0">{{scope.row.inventory}}</span>
	          	    </template>
	          	</el-table-column>
	      	</el-table>
      		<div class="block">
            <!--分页begin-->
            <el-pagination
	            @size-change="productPageSizeChange"
	            @current-change="productPageCurrentChange"
	            :current-page="productquery.p"
	            :page-sizes="[10, 20, 50]"
	            :page-size="productquery.rollpage"
	            layout="total, sizes, prev, pager, next, jumper"
	            :total="total_product_rows">
            </el-pagination>
            <!--分页end-->
      		</div>
	        <div slot="footer" class="dialog-footer">
	            <el-button size="medium" @click="addDialog = false">取 消</el-button>
	            <el-button size="medium" type="primary" :loading="addProductLoading" @click="addSave">确认添加</el-button>
	        </div>	        
  		</el-dialog>
  		<!--------------------------------批量添加end--------------------------->
  
  		<!--------------------------------打印信息 start ------------------------------->
  		<el-dialog title="确认打印" :visible.sync="printerDialog" width="80%" top="5vh">
  	  			<div class="print-sell">
  	  				每页展示  <input type="text" v-model="rollpage"  v-on:blur="changepagevlaue()"  class="print-sell-page" />  条
  	  			</div>	
      			<div id="printContent" v-loading="printLoading" style="overflow:hidden">
          			<div v-for="(iit,i) in prpage" id="printpages">
          	  			<span class="print-sell-page-show" >{{iit.id}}/{{allprintpage}}</span>
	      	  			<DIV class="print-sell-page-title" align="center" v-if="printsmodel.title==1"><STRONG>{{printsmodel.titlevalue}}</STRONG></DIV>        
						<div class="tabletitle-container">
							<el-row :gutter="20">
								<el-col :span="8">
									<div v-if="printsmodel.customer_name==1" class="list-item left-col">客户名称：{{printorderdetail.customerName}}</div>
									<div v-if="printsmodel.deliverdate==1" class="list-item left-col">交货日期：{{printorderdetail.deliverdate}}</div>
									<div v-if="printsmodel.contactname==1" class="list-item left-col">收货人姓名：{{printorderdetail.contactname}}</div>
									<div v-if="printsmodel.contactphone==1" class="list-item left-col">收货电话：{{printorderdetail.contactphone}}</div>
								</el-col>
								<el-col :span="8">
									<div v-if="printsmodel.note==1" class="list-item center-col">出库备注：{{printorderdetail.note}} {{printorderdetail.ordernumber ? `（商城单号：${printorderdetail.ordernumber}）` : ''}}</div>
								</el-col>
								<el-col :span="8">
									<div v-if="printsmodel.documents==1" class="list-item right-col">单据编号：{{printorderdetail.documents}}</div>
									<div v-if="printsmodel.clerkname==1" class="list-item right-col">销售人员：{{printorderdetail.clerkName}}</div>
									<div v-if="printsmodel.accountname==1" class="list-item right-col">支付方式：<span>{{printorderdetail.accountName}}</span></div>
								</el-col>
							</el-row>
							<el-row>
								<el-col :span="24">
									<div v-if="printsmodel.address==1" class="list-item full-row">收货地址：{{printorderdetail.address}}</div>
								</el-col>
							</el-row>
						</div>
	          			<TABLE border=1 cellSpacing=0 cellPadding=1 width="100%" class="print-sell-page-table">
			 			    <tr class="contactcontent">
				                <TD v-if="printsmodel.number==1" ><DIV align=center><b>编号</b></DIV></TD>
				                <TD v-if="printsmodel.product_name==1" align="center">
									<DIV style="float:left;width:100%;"><b>品名</b></DIV>
								</TD>
				                <TD  v-if="printsmodel.product_spec==1" ><DIV align=center><b>规格</b></DIV></TD>
				                <TD v-if="printsmodel.unit==1" ><DIV align=center><b>单位</b></DIV></TD>
				                <TD v-if="printsmodel.num==1" ><DIV align=center><b>数量</b></DIV></TD>
				                <TD v-if="printsmodel.sell==1" ><DIV align=center><b>售价</b></DIV></TD>
				                <TD v-if="printsmodel.discount==1" ><DIV align=center><b>折扣</b></DIV></TD>
				                <TD v-if="printsmodel.dis_sell==1" ><DIV align=center><b>折后单价</b></DIV></TD>
				                <TD v-if="printsmodel.market==1" ><DIV align=center><b>零售价</b></DIV></TD>  
				                <TD v-if="printsmodel.account==1" ><DIV align=center><b>小计</b></DIV></TD>
				                <TD v-if="printsmodel.warehourse==1" ><DIV align=center><b>仓库</b></DIV></TD>
				                <TD v-if="printsmodel.desc==1" ><DIV align=center><b>备注</b></DIV></TD>
				                <TD v-if="printsmodel.type==1" ><DIV align=center><b>类型</b></DIV></TD>
			                </tr>
				            <tr v-for="(item,index) in printorderdetail.goods" :key="index"  class="contactcontent" v-if="index >= prollpage[i]['startpage'] && index <= prollpage[i]['endpage'] ">
					            <TD v-text="item.number" align="center" v-if="printsmodel.number==1"></TD>
					            <TD style="padding-left:1%" v-if="printsmodel.product_name==1">
									<div style="float:left;width:100%;overflow:hidden;height:21px">{{item.name}}</div>
								</TD>
					            <TD v-text="item.spec" align="center" v-if="printsmodel.product_spec==1"></TD>
					            <TD v-text="item.unit" align="center" v-if="printsmodel.unit==1"></TD>
					            <TD v-text="item.num" align="center" v-if="printsmodel.num==1"></TD>
					            <TD v-text="item.sell" align="center" v-if="printsmodel.sell==1"></TD>
					            <TD v-text="item.discount" align="center" v-if="printsmodel.discount==1"></TD>
					            <TD v-text="item.dis_sell" align="center" v-if="printsmodel.dis_sell==1"></TD>
					            <TD v-text="item.market" align="center" v-if="printsmodel.market==1"></TD>
					            <TD v-text="item.total" align="center" v-if="printsmodel.account==1"></TD>
					            <TD v-text="item.warename" align="center" v-if="printsmodel.warehourse==1"></TD>
					            <TD v-text="item.desc" style="padding-left:1%" v-if="printsmodel.desc==1"></TD>
					            <TD v-text="item.showtype" align="center" v-if="printsmodel.type==1"></TD>
				            </tr>
			                <tr v-if="iit.id==allprintpage">
				                <TD align="center" v-if="printsmodel.number==1 || printsmodel.product_name==1"><b>合计</b></TD>
				                <TD v-if="printsmodel.number==1 && printsmodel.product_name==1"></TD>
				                <TD v-if="printsmodel.product_spec==1"></TD>
				                <TD v-if="printsmodel.unit==1">&nbsp;</TD>
				                <TD v-if="printsmodel.num==1" align="center">{{printorderdetail.allnumber}}</TD>
				                <TD v-if="printsmodel.sell==1">&nbsp;</TD>
				                <TD v-if="printsmodel.discount==1">&nbsp;</TD>
				                <TD v-if="printsmodel.dis_sell==1">&nbsp;</TD>
				                <TD v-if="printsmodel.market==1">&nbsp;</TD>
				                <TD align="center" v-if="printsmodel.account==1">{{printorderdetail.total}}</TD>
				                <TD v-if="printsmodel.warehourse==1">&nbsp;</TD>
				                <TD v-if="printsmodel.desc==1">&nbsp;</TD>
				                <TD v-if="printsmodel.type==1">&nbsp;</TD>
			                </tr>
	      	  			</table>
	          			<TABLE border=0 cellSpacing=0 cellPadding=0 width="100%">
		          			<TBODY>
			          			<TR class="top1">
			          				<TD v-if="printsmodel.inputdate==1"><span>录单日期：{{printorderdetail.inputdate}}</span></TD>
				          			<TD v-if="printorderdetail.verifyername!=''"><span>审核人：{{printorderdetail.verifyername}}</span></TD>
				          			<TD v-if="printsmodel.sysmanagername==1"><span>操作人：{{printorderdetail.sysmanagername}}</span></TD>
			          			</TR>
			          			<TR class="top1">				          			
				          			<TD v-if="printsmodel.total==1"><span>应付金额：{{printorderdetail.real}} 元</span></TD>
				          			<TD v-if="printsmodel.isexpress==1"><span>快递费用：{{printorderdetail.express}} 元</span></TD>				          			
			          				<TD v-if="printsmodel.derate==1"><span>优惠金额：{{printorderdetail.derate}} 元</span></TD>
									<TD v-if="printsmodel.isdriver==1"><span>是否司机收款：{{printorderdetail.isdriver==0 ? '否' : '是'}}</span></TD>
			          			</TR>
						      	<TR class="top1" v-if="printsmodel.print==1"">
						            <TD :colspan="4"><span>{{printsmodel.printvalue}}</span></TD>
						      	</tr>
				      			<TR class="top2">
						            <TD><span v-if="printsmodel.p_man==1">配货人</span></TD>
						            <TD><span v-if="printsmodel.s_man==1">送货人</span></TD>
						            <TD><span v-if="printsmodel.ss_man==1">收货人</span></TD>
						            <TD>&nbsp;</TD>
						            <TD>&nbsp;</TD>
				      			</tr>
		          			</TBODY>
	          			</TABLE>
						<div class="pageBreak"></div>
          			</div>    
	  			</div>

  			</el-dialog>
  			<!--------------------------------打印信息 end--------------------------->
  			
  </div>
  </transition>
</template>

<script>
/* 导入拖拽组件 */
import draggable from 'vuedraggable'

export default {
  components: {draggable},

  data () {
    return {
      url:this.GLOBAL.domain+"Sell/index",
      transitionshow:true,
      actionauth:'',
      lists:[],
      addandeditsellDialog:false,
      listLoading:false,
      search:{
        act:'barcode',
        token:this.$cookies.get('token'),
        key:'',
        customer:''
      },
      query:{
        act:'lists',
        token:this.$cookies.get('token'),
        customerid:'',
        searchcustomerid:1,
        rollpage: 1000, // 页大小
        p: 1,
        carttype:1,
      },
      total_rows:0,
      customerLists:[],
      wareHouseLists:[],
      accountLists:[],
      nums:[],
      sells:[],
      discounts:[],
      disells:[],
      totals:[],
      warehouses:[],
      categorylist:[],
      desc:[],
      create:{
        act:'add',
        token:this.$cookies.get('token'),
        deliverdate:new Date().getFullYear().toString() + '-' + (new Date().getMonth()+1) + '-' + new Date().getDate(),
        id:'',
        account:'',
        documents:'',
        note:'',
        total:0.00,
        derate:0.00,
        express:0.00,
        seller:'',
        customer:'',
        verifyer:'',
        sysmanager:'',
        shipping:'',
        shippingcode:'',
        status:0,
        'type':'save',
        'carttype':'',
      },
      unitLoading:false,
      unitDialog:false,
      showprinterDialog:false,
      unitlists:[],
      unitListLoading:false,
      changeunitid:0,
      addDialog:false,
      addListLoading:false,
      productquery:{
        act:'inventory',
        token:this.$cookies.get('token'),
        brandid:'',
        catid:'',
        warehouse:'',
        customerid:'',
        key:'',
        rollpage: 10, // 页大小
        p: 1
      },
      productlists:[],
      brandlists:[],
      total_product_rows:0,
      addProductLoading:false,
      multipleSelection: [],
      customerLoading:false,
      sellerLists:[],
      wareDialog:false,
      wareListLoading:false,
      accountName:'未支付',
      customerName:'',
      contactname:'',
      contactphone:'',
      sysmanagername:'',
      address:'',
      printdesc:'',
      totalprice:0.00,
      printerDialog:false,
      clerkName:'',
      isshowtype:0,
      inputdate:new Date().getFullYear().toString() + '-' + (new Date().getMonth()+1) + '-' + new Date().getDate(),
      typeDialog:false,
      typearr:[
      	{name:'消费'},
      	{name:'赠送'},
      	{name:'自用'},
      	{name:'报废'},
      	{name:'欠货'}
      ],
      shippings:[
      	{id:'1',name:'线下配送'},
      	{id:'2',name:'物流'},
      	{id:'3',name:'快递'},
      	{id:'4',name:'自提'}
      ],
      ordertype:[
      	{id:0,name:'收银台出库单'},
		{id:1,name:'线上商城出库单'},
      	{id:3,name:'业务员出库单'},
		{id:4,name:'分销出库单'}
      ],
      
      printsmodel:[],
      pclickstatus:[],
      isnewselect:false,
      isopenselect:true, //是否开启点击单行自动选择
      putsave:{
        act:'putorder',
        token:this.$cookies.get('token'),
        deliverdate:'',
        account:'',
        documents:'',
        note:'',
        total:'0.00',
        derate:'0.00',
        express:'0.00',
        seller:'',
        customer:'',
        sysmanager:'',
        shipping:'',
        shippingcode:'',
      },
      
      putnumber:0,
      putnumberlists:[],
      putSearch: {
      	act:'getputorderlists',
        token:this.$cookies.get('token'),
        customer:'',
        date:[],
        documents:'',
        seller:'',
        p:1,
        rollpage:10,
      },
      putListLoading:false,
      total_put_rows:0,
      putDialog:false,
      isputchange:false,
      sureprint:false,
      
      prpage:[],
	  prollpage:[],
	  prtotal:0,
	  rollpage:'',
	  allprintpage:'',
	  defaultwarehouseid:'', //默认发货仓库
	  
	  order: {
	  	  act:'getsellorderlists',
	  	  date:'',
	  	  customerid:'',
	  	  seller:'',
	  	  status:'',
	  	  key:'',
	  	  account:'',
	  	  ordertype:'',
		  keytype:1,
		  sourceagentid:0,
	  	  token:this.$cookies.get('token'),
	  	  p:1,
	  	  rollpage:10
	  },
	  total_order_rows:0,
	  orderstatus:[
	  	{id:0,name:'未审核'},
	  	{id:1,name:'已审核'},
	  	{id:2,name:'已完成'},
	  	{id:3,name:'已撤销'},
	  ],
	  keytypelists:[{id:1,name:'按订单号'},{id:2,name:'按商品名称 / 编号 / 条形码'}],
	  orderlists:[],
	  orderListLoading:false,
	  orderaddLoading:false,
	  suresellLoading:false,
	  sellverifyLoading:false,
	  selldelLoading:false,
	  printorderdetail:[],
	  printLoading:false,
	  printorderLoading:false,
	  cannelLoading:false,
	  finishLoading:false,
	  orderisselect:false,
	  sellverifyprintLoading:false,
	  showsort:0,
	  showsorttype:'success',
	  showsorticon:'el-icon-circle-check-outline',
	  showsortname:'启用排序',
	  listsorts:[],
	  selectdouble:false, //鼠标双击开关
	  nowtime:0,
	  timeoutflag:true,
	  sourceagents:[], //商城、分销订单来源
    }
  },
    
  mounted(){  
  	this.getOrderlists(); //获取销售订单列表
  	this.getactionauth(); //获取权限设置
    this.getWarehouse();  //仓库列表
    this.getAccount(); //支付账号列表
    this.getList();  //查询商品信息列表
    this.getSeller(); //获取销售员列表
    this.getSysmanager(); //获取操作人列表
    this.getPrintdesc(); //获取默认打印信息
    this.getCategoryList(); //获取分类列表
    this.getprintsmodel(); //获取打印显示模板信息
    this.getdefaultwarehouse(); //获取默认发货仓库    
	this.getsourceagent(); //获取线上商城、分销订单来源
  },
  
  
  methods:{
  
    /** 重置表单 **/
    reset() {
        this.$refs.create.resetFields();
        this.create.derate='0.00';
        this.setDocuments();
        this.search.customer='';
    },
    
    /** 获取操作功能权限 **/
  	getactionauth() {
    	var data =this.$cookies.get('actionauth');
    	data=JSON.parse(data);
        this.actionauth=data;
    },

	/** 获取线上发货单来源代理商 **/
    getsourceagent() {
		var resource = this.$resource(this.url);
        resource.query({act:'getsourceagent',token:this.$cookies.get('token')}).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
            }else{
                this.sourceagents = JSON.parse(Base64.decode(res.data.Data));
            }
        }).catch((res) => {
            
        });
	},

    
    //获取订单信息列表
    getOrderlists() {
    	if(this.orderisselect==true) {
    		this.order.p=1;
    		this.order.rollpage=10;
    	}
    
    	this.orderListLoading=true;
    	var resource = this.$resource(this.url);
        resource.save(this.order).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
                this.orderListLoading=false;
            }else{
                this.orderlists = JSON.parse(Base64.decode(res.data.Data));
                this.total_order_rows=parseInt(res.data.count);
                this.orderListLoading=false;
                if(this.orderisselect==true) this.orderisselect=false;

				//取消跑店小程序的信息提示
				this.$emit('cannelnotice',2);
            }
        }).catch((res) => {
            this.orderListLoading=false;
        });
    },
    
    orderPageSizeChange(val) {
        this.order.rollpage = val;
        this.getOrderlists();
    },
    orderPageCurrentChange(val) {
        this.order.p = val;
        this.getOrderlists();
    },
    
    
    /** 新增订单 **/
    addnews() {   
    	this.$emit('listenchild',{name:'新增销售订单',url:'Selladd'});
    	/**
    	//清空购物车商品
    	this.orderaddLoading=true;
 
    	//重置订单数据信息    	
		this.create.id='';
		this.create.deliverdate='';
		this.create.account='';
		this.create.note='';
		this.create.total='';
		this.create.derate=0.00;
		this.create.express=0.00;
		this.create.seller='';
		this.create.customer='';
		this.create.verifyer='';
		this.create.shipping='1';
		this.create.shippingcode='';
		this.create.status=0;
		this.create.carttype=1;
		this.search.customer='';
		//获取单据编号
        this.setDocuments();
        //设置查看购物车商品类型（1、添加商品订单 2、编辑商品订单）
    	this.query.carttype=1;
    	//获取购物车商品信息（添加商品订单类型）
    	this.getList();
    	//统计商品的合计价格
    	this.getTotal();
        this.addandeditsellDialog=true;
        this.orderaddLoading=false;
      	*/  
    },
    
    /** 编辑订单信息 **/
    editorder(item) {
    	this.$emit('listenchild',{name:'编辑销售订单',url:'Selledit',data:{id:item.id}});
    
    	//清空购物车商品
    	/**
    	var resource = this.$resource(this.url);
        resource.save({ act:'getorderinfos',id:item.id,carttype:2,token:this.$cookies.get('token')}).then((res) => {
        	if(res.data.Result>0){
            	if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
            }else{
            	//重置数据    	
            	var result = JSON.parse(Base64.decode(res.data.Data));            	
            	this.create.id=result.id;
		      	this.create.deliverdate=result.deliverdate;
		      	this.create.account=result.account==0 ? 0 : result.account;
		      	this.create.documents=result.documents;
		      	this.create.note=result.note;
		      	this.create.derate=result.derate;
		      	this.create.express=result.express;
		      	this.create.customer=result.customerid > 0 ? result.customerid : '';
		      	this.search.customer=result.customerid > 0 ? result.customername : '';
		      	this.productquery.customerid=result.customerid;
		      	this.create.sysmanager=result.managerid;
		      	this.create.shipping=result.shipping;
		      	this.create.shippingcode=result.shippingcode;
		      	this.create.verifyer=result.verifyer==0 ? '' : result.verifyer;
		      	this.create.seller=result.clerkid;
		      	this.create.status=result.status;
		      	this.create.carttype=2;
		      	this.query.carttype=2;
            	
            	this.getList();
                this.getTotal();
                this.addandeditsellDialog=true;
            }
        }).catch((res) => {
            
        });
        */
    },
    
    
    
    /** 出库单号 **/
    setDocuments(){
        var resource = this.$resource(this.url);
        resource.query({act:'getxsdocuments',documents:this.create.documents,token:this.$cookies.get('token')}).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
            }else{
                var result = JSON.parse(Base64.decode(res.data.Data));
                this.create.documents=result;
            }
        }).catch((res) => {
            //this.$message.error(this.GLOBAL.errortext);
        });
    },
    
    
    /** 自定义修改订单编号 **/
    changeDocuments(code) {
    	var title=code.substring(0,2); 
    	var year=code.substring(2,6); 
    	var month=code.substring(6,8); 
    	var day=code.substring(8,10); 
    	var number=code.substring(10,15); 
    	return title+'-'+year+'-'+month+'-'+day+'-'+number;
    },
    
    
    /** 获取客户 **/
    getCustomer(query){
        if (query !== '') {
	        this.customerLoading = true;
	        var resource = this.$resource(this.GLOBAL.domain+"Customer/index");
	        resource.query({act:'lists',key:query,token:this.$cookies.get('token')}).then((res) => {
	            if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
		            this.customerLoading = false;
	            }else{
		            this.customerLists = JSON.parse(Base64.decode(res.data.Data));
		            this.customerLoading = false;
	            }
	        }).catch((res) => {
	            //this.$message.error(this.GLOBAL.errortext);
	            this.customerLoading = false;
	        });
        }
    },
    
    
    /** 获取仓库 **/
    getWarehouse(){
        var resource = this.$resource(this.GLOBAL.domain+"Ware/index");
        resource.query({act:'lists',token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	            this.wareHouseLists = JSON.parse(Base64.decode(res.data.Data));
	        }
        }).catch((res) => {
            //this.$message.error(this.GLOBAL.errortext);
        });
    },
    
    
    /** 获取销售员 **/
    getSeller(){
        var resource = this.$resource(this.GLOBAL.domain+"Clerk/index");
        resource.query({act:'lists',token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	            this.sellerLists = JSON.parse(Base64.decode(res.data.Data));
	            //默认选择第一个销售员
	            if(this.sellerLists!='') this.create.seller=this.sellerLists[0]['id'];	                      
	        }
        }).catch((res) => {
            //this.$message.error(this.GLOBAL.errortext);
        });
    },
    
    
    /** 获取经手人 **/
    getSysmanager() {
        var resource = this.$resource(this.GLOBAL.domain+"Manager/index");
        resource.query({act:'lists',token:this.$cookies.get('token'),rollpage:1000,p:1}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	            this.sysmanagers = JSON.parse(Base64.decode(res.data.Data));
	            this.create.sysmanager=this.$cookies.get('managerid');            
	        }
        }).catch((res) => {
            //this.$message.error(this.GLOBAL.errortext);
        });
    },
    
    
    /** 获取银行帐户 **/
    getAccount(){
        var resource = this.$resource(this.GLOBAL.domain+"Account/index");
        resource.query({act:'lists',isdeposit:1,isnopay:1,token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	            this.accountLists = JSON.parse(Base64.decode(res.data.Data));
	        }
        }).catch((res) => {
            //this.$message.error(this.GLOBAL.errortext);
        });
    },
    
    
    /** 获取打印设置信息 **/
    getPrintdesc() {
        var resource = this.$resource(this.GLOBAL.domain+"Setting/index");
        resource.query({act:'getprintinfo',token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
	        if(res.data.Result>0){
	          	if(res.data.Result=='70001') this.$router.push('/login')
	          	this.$message.error(res.data.Message);
	        }else{
	            this.printdesc = JSON.parse(Base64.decode(res.data.Data));
	        }
        }).catch((res) => {
            //this.$message.error(this.GLOBAL.errortext);
        });
    },
    
    
    /** 获取入库信息列表 **/
    getList(){
        this.listLoading = true;
        var resource = this.$resource(this.url);
        resource.query(this.query).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.listLoading = false;
	            this.query.searchcustomerid=0;
	        }else{
	            this.lists = JSON.parse(Base64.decode(res.data.Data));
	            this.listsorts=[];
	            const _this=this;
	            this.lists.forEach(function(e,index){  
	            	_this.nums.splice(index, 1, e.num);
	           		_this.totals.splice(index,1,e.total);
		            _this.discounts.splice(index,1,e.discount);
		            _this.sells.splice(index,1,e.sell);
		            _this.disells.splice(index,1,e.dis_sell);
		            _this.desc.splice(index,1,e.desc);
		            _this.isshowtype=e.isshowconsume;
		            
		            //获取排序商品信息
		            _this.listsorts.push({id:e.id,number:e.number,name:e.name,spec:e.spec,unit:e.unit,num:e.num,sell:e.sell,discount:e.discount,dis_sell:e.dis_sell,total:e.total,warename:e.warename,type:e.type});
	            });
	
	            this.total_rows=parseInt(res.data.count);
	            this.listLoading = false;
	            this.query.searchcustomerid=0;
	            this.getTotal();
	        }
        }).catch((res) => {
            //this.$message.error(this.GLOBAL.errortext);
            this.listLoading=false;
            this.query.searchcustomerid=0;
        });
    },
    
    
    pageSizeChange(val) {
        this.query.rollpage = val;
        this.getList();
    },
    pageCurrentChange(val) {
        this.query.p = val;
        this.getList();
    },
    
    
    /** 修改单位 **/
    changeUnit(item){
        this.unitDialog=true;
        this.unitListLoading = true;
        this.changeunitid=item.id;
        var resource = this.$resource(this.url);
        resource.query({act:'getunit',productid:item.productid,customer:this.search.customer,token:this.$cookies.get('token')}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.unitListLoading = false;
	        }else{
	            this.unitlists = JSON.parse(Base64.decode(res.data.Data));
	            this.unitListLoading = false;
	        }
        }).catch((res) => {
            //this.$message.error(this.GLOBAL.errortext);
            this.unitListLoading=false;
        });
    },
    
    
    /** 确认修改单位 **/
    changeUnitSave(item){    
    	var _this=this;
        this.unitListLoading=true;
        var resource = this.$resource(this.url);
        resource.save({act:'changeunit',id:item.id,tempid:this.changeunitid,customer:this.search.customer,token:this.$cookies.get('token')}).then((res) => {
            if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.unitListLoading=false;
            }else{
	            this.unitListLoading=false;
	            this.getList();	            
	            this.getTotal(); //重新计算总价
	            
            }
        }).catch((res) => {
            //this.$message.error(this.GLOBAL.errortext);
            this.unitListLoading=false;
        });
        this.unitDialog=false;
    },
    
    
    /** 修改数量 **/
    changeNum(index,item){
        var resource = this.$resource(this.url);
        resource.save({act:'changenum',id:item.id,num:this.nums[index],token:this.$cookies.get('token')}).then((res) => {
          if(res.data.Result>0){
              if(res.data.Result=='70001') this.$router.push('/login')
              this.$message.error(res.data.Message);
              this.listLoading=false;
              this.getList();
              this.getTotal();
          }else{
              this.getList();
              this.getTotal();
          }
        }).catch((res) => {
            //this.$message.error(this.GLOBAL.errortext);
        });
    },
    
    
    /** 修改折扣 **/
    changediscounts(index,item){      
        var resource = this.$resource(this.url);
        resource.save({act:'changediscounts',id:item.id,discounts:this.discounts[index],token:this.$cookies.get('token')}).then((res) => {
          if(res.data.Result>0){
              if(res.data.Result=='70001') this.$router.push('/login')
              this.$message.error(res.data.Message);
              this.getList();
              this.getTotal();
          }else{
              this.getList();
              this.getTotal();
          }
        }).catch((res) => {
            //this.$message.error(this.GLOBAL.errortext);
        });
    },
    
    
    /** 修改售价 **/
    changesells(index,item) {
        var resource = this.$resource(this.url);
        resource.save({act:'changesells',id:item.id,sells:this.sells[index],token:this.$cookies.get('token')}).then((res) => {
            if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.getList();
	            this.getTotal();
            }else{
	            this.getList();
	            this.getTotal();
            }
        }).catch((res) => {
            //this.$message.error(this.GLOBAL.errortext);
        });	
    },
    
    
    /** 修改折后单价 **/
    changedisells(index,item) {
        var resource = this.$resource(this.url);
        resource.save({act:'changedissells',id:item.id,disells:this.disells[index],token:this.$cookies.get('token')}).then((res) => {
            if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.getList();
	            this.getTotal();
            }else{
	            this.getList();
	            this.getTotal();
            }
        }).catch((res) => {
            //this.$message.error(this.GLOBAL.errortext);
        });
    },
    
    
    /** 修改总价 **/
    changeTotal(index,item){
        var resource = this.$resource(this.url);
        resource.save({act:'changetotal',id:item.id,total:this.totals[index],token:this.$cookies.get('token')}).then((res) => {
          if(res.data.Result>0){
              if(res.data.Result=='70001') this.$router.push('/login')
              this.getList();
              this.getTotal();
              this.$message.error(res.data.Message);
          }else{
              this.getList();
              this.getTotal();
          }
        }).catch((res) => {
            //this.$message.error(this.GLOBAL.errortext);
        });
    },
    
    
    /** 修改客户名称 **/
    changesellcustomer() {
    	this.create.customer=this.search.customer;
    	this.query.customerid=this.search.customer;
    	this.productquery.customerid=this.search.customer;
    	this.query.searchcustomerid=1;
    	var clerkid='';
    	
    	//自动根据客户匹配绑定的销售员
    	var _this=this;
    	this.customerLists.forEach(function(item,i) {
    		if(item.id==_this.search.customer) clerkid=item.clerkid;    	    	
    	});
    	
    	this.sellerLists.forEach(function(item,i) {
    		if(item.id==clerkid) _this.create.seller=clerkid;
    	});
    	
    	this.getList(); //刷新收银台界面
    },
    
    
    /** 修改仓库 **/
    changeWare(item){
        this.wareDialog=true;
        this.wareListLoading = true;
        this.getWarehouse();
        this.changeunitid=item.id;
        this.wareListLoading = false;
    },
    
    
    /** 确认修改仓库 **/
    changeWareSave(item){
        var resource = this.$resource(this.url);
        resource.save({act:'changeware',id:this.changeunitid,warehouse:item.id,token:this.$cookies.get('token')}).then((res) => {
            if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
		            this.wareDialog=false;
	            }else{
		            this.getList();
		            this.wareDialog=false;
            }
        }).catch((res) => {
            //this.$message.error(this.GLOBAL.errortext);
            this.wareDialog=false;
        });
    },
    
    
    /** 修改类型 **/
    changeType(item){
        this.typeDialog=true;
        this.changeunitid=item.id;
    },
    
    
    /** 确认修改类型 **/
    changeTypeSave(item){
        var resource = this.$resource(this.url);
        resource.save({act:'changetype',id:this.changeunitid,type:item.name,token:this.$cookies.get('token')}).then((res) => {
            if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.typeDialog=false;
	        }else{
	            this.getList();
	            this.getTotal();
	            this.typeDialog=false;
            }
        }).catch((res) => {
            //this.$message.error(this.GLOBAL.errortext);
            this.typeDialog=false;
        });
    },
    
    
    /** 修改商品备注信息 **/
    changedesc(index,item) {
	    var resource = this.$resource(this.url);
	    resource.save({act:'changedesc',id:item.id,desc:this.desc[index],token:this.$cookies.get('token')}).then((res) => {
	          if(res.data.Result>0){
	            if(res.data.Result=='70001'){
	              this.$router.push('/login')
	            }
	            this.$message.error(res.data.Message);
	          }else{
	            this.getList();
	            this.getTotal();
	          }
	    }).catch((res) => {
	          //this.$message.error(this.GLOBAL.errortext);
	    });
    },
    
    
    /** 删除购物车商品 **/
    delCurrent(item){
        this.$confirm('此操作将删除 ' + item.name + ', 是否继续?', '提示', { type: 'warning' }).then(() => {
        	// 向请求服务端删除
            var resource = this.$resource(this.url);
            resource.save({ act:'del',id: item.id,token:this.$cookies.get('token')}).then((res) => {
            	if(res.data.Result>0){
                    if(res.data.Result=='70001') this.$router.push('/login')
                    this.$message.error(res.data.Message);
                }else{
                    this.$message.success('成功删除了' + item.name + '!');
                    this.getList();
                    this.getTotal();
                }
            }).catch((res) => {
            	//this.$message.error(this.GLOBAL.errortext);
            });
        }).catch(() => {
            //this.$message.info('已取消操作!');
        });
    },
    
    /** 该条信息在购物车里多复制一条 **/
    copyCurrent(item) {
    	this.$confirm('你是否确定要复制 ' + item.name + '商品, 是否继续?', '提示', { type: 'warning' }).then(() => {
        	this.multipleSelection=[];
        	this.multipleSelection.push({id:item.productid,warehouse:item.warehouse,price:item.sell});
        	this.addSave();
        }).catch(() => {
            //this.$message.info('已取消操作!');
        });
    },
    
    
    /** 扫码添加商品信息 **/
    addDialogsingle() {
    	this.multipleSelection=[];
    	var resource = this.$resource(this.url);
        resource.query({act:'sweep',customer:this.search.customer,key:this.productquery.key,token:this.$cookies.get('token')}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	        	if(Base64.decode(res.data.Data)==1) { //有1个以上则展开列表
	        		this.productquery.warehouse=''; 
	        		this.addDialogShow();
	        		this.productquery.key='';
	        	}else { //扫码解析同一个产品只有1个则直接添加
	        		this.productquery.warehouse='';
	        		this.multipleSelection.push(JSON.parse(Base64.decode(res.data.Data)));
	        		this.addSave();
	        		this.productquery.key='';
	        	}
	        }
        }).catch((res) => {
            //this.$message.error(this.GLOBAL.errortext);
        });
    },
    
    
    /** 点击批量添加商品按钮 **/
    addmoregoods() {  
    	if(this.showsort==1) {this.$message.error("请先选择终止排序");return false;}
    
    	//重置商品搜索  
    	this.productquery.brandid='';
    	this.productquery.catid='';
    	this.productquery.key='';
    	this.productquery.warehouse=this.defaultwarehouseid==0 ? '' : this.defaultwarehouseid;
    	this.productquery.p=1;
    	this.productquery.rollpage=10;
    	
    	//清空已选中的商品
    	this.multipleSelection=[];    	
    	this.addDialogShow();
    	
    	//开启已选商品
    	
    },
    
    
    /** 批量搜索商品 **/
    addDialogsinglesearch() {
    	this.multipleSelection=[];
    	this.productquery.warehouse='';
    	this.addDialogShow();
    },
    
    /** 批量添加商品 **/
    addDialogShow(){
        this.addDialog=true;
        this.getWarehouse();
        this.getBrand();
        this.getProductList();
    },
    
    /** 搜索关键字实时刷新数据 **/
    changesearchkey() {
    	//网络异常请求加载数据缓慢时禁止向服务器请求加载数据，缓解服务器压力，等上一次数据加载完后再重亲请求加载数据
    	if(this.listLoading==true) {return false;}
    	this.getProductList();
    },
    
    /** 获取品牌 **/
    getBrand(){
        var resource = this.$resource(this.GLOBAL.domain+"Brand/index");
        resource.query({act:'lists',token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	        	var _this=this;
	            var result = JSON.parse(Base64.decode(res.data.Data));
	            this.brandlists=[];
	            result.forEach(function(e,i) {
	            	_this.brandlists.push({id:e.id,name:e.name});
	            });
	        }
        }).catch((res) => {
            //this.$message.error(this.GLOBAL.errortext);
        });
    },
    
    
    /** 产品信息列表 **/
    getProductList(){
    	if(this.isnewselect==true) {
			this.productquery.p=1;
			this.productquery.rollpage=10;	    	
    	}
    
    	var _this=this;
        this.addListLoading = true;
        var resource = this.$resource(this.url);
        resource.query(this.productquery).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.addListLoading = false;
	        }else{
	            this.productlists = JSON.parse(Base64.decode(res.data.Data));
	            this.total_product_rows=parseInt(res.data.count);
	            this.checkselectgoods();
	            
	            this.pclickstatus=[];
	            this.productlists.forEach(function() {
	            	_this.pclickstatus.push(0);
	            });	            
	            this.addListLoading = false;
	        }
	        
	        if(this.isnewselect==true) this.isnewselect=false;
        }).catch((res) => {
            //this.$message.error(this.GLOBAL.errortext);
            this.addListLoading=false;
            if(this.isnewselect==true) this.isnewselect=false;
        });
    },
      
    productPageSizeChange(val) {
        this.productquery.rollpage = val;
        this.getProductList();
    },
    productPageCurrentChange(val) {
        this.productquery.p = val;
        this.getProductList();
    },
    
    
    /** 商品出库 **/
    addSave(){    	 
        this.addProductLoading=true;
        var resource = this.$resource(this.url);
        resource.save({act:'addproduct',customer:this.search.customer,productid:this.multipleSelection,carttype:this.query.carttype,token:this.$cookies.get('token')}).then((res) => {
            if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.addProductLoading=false;
            }else{
                this.$message.success(res.data.Message);
                this.addDialog=false;
                this.addProductLoading=false;
                this.getList();
                this.getTotal();
            }
        }).catch((res) => {
            //this.$message.error(this.GLOBAL.errortext);
            this.addDialog=false;
            this.addProductLoading=false;
        });
    },
    
    
    /** 点击事件（单击、双击） **/
    rowclick(val,row) {
    	this.nowtime ++;
    	if(this.timeoutflag==false) return false;
    	
    	var _this=this;
    	this.timeoutflag=false;
    	setTimeout(function() {
    		if(_this.nowtime==1) { //单击事件
    			_this.selectrow(val,row);
    		}else { //双击事件
    			_this.selectsingle(val,row);
    		}
    		_this.nowtime=0;
    		_this.timeoutflag=true;
    	},250);
    	
    },
    
   
    /** 点击单行触发事件 **/
    selectrow(row,event) {
    	var _this=this;
		var id=row.id;
		var number=0;
		var isselect=0;
		    	
		//勾选/取消勾选选中商品信息
		_this.productlists.forEach(function(e,index) {
		    if(id==e.id) {
		    	_this.$refs.multipleTable.toggleRowSelection(_this.productlists[index]);
		    	number=index;
		    }
		});		
		//判断该商品在选取列表里是否存在，存在则删除该商品，不存在则添加该商品		
		_this.multipleSelection.forEach(function(e,index) {if(id==e.id) isselect=1});
				
		if(isselect==1) {
			_this.multipleSelection.forEach(function(e,index) {if(id==e.id) _this.multipleSelection.splice(index,1)});
		}else {	
			_this.multipleSelection.push(row);
												
			//异步判断添加的商品是否满足添加的要求（判断商品库存）
			var resource = _this.$resource(_this.url);
			resource.save({act:'checkinventorys',product:row,token:this.$cookies.get('token')}).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') _this.$router.push('/login');
					_this.$message.error(res.data.Message);
				}else{
				    var data=Base64.decode(res.data.Data);
				    if(data==2) { //库存不足时提示欠货处理
				    	_this.$confirm(row.name+'库存不足，出库时将作为欠货商品处理，您是否要添加该商品', '提示', { type: 'warning' }).then(() => {
				        	//确认添加按原来的方式，此处不做任何处理
						}).catch(() => {
						    //取消操作时，取消勾选的商品
						    _this.$refs.multipleTable.toggleRowSelection(_this.productlists[number]);
						    //勾选的商品列表里剔除该商品
						    _this.multipleSelection.forEach(function(e,index) {if(id==e.id) _this.multipleSelection.splice(index,1)});				       		
						});
					}
				}
			}).catch((res) => {
				        	
			});
		}
    },
    
    /** 双击单行商品选择添加进购物车 **/
    selectsingle(row,event) {
    	var _this=this;
		var id=row.id;
		var number=0;
		var isselect=0;
		    	
		//勾选/取消勾选选中商品信息
		_this.productlists.forEach(function(e,index) {
		    if(id==e.id) {
		    	_this.$refs.multipleTable.toggleRowSelection(_this.productlists[index]);
		    	number=index;
		    }
		});		
		//判断该商品在选取列表里是否存在，存在则删除该商品，不存在则添加该商品		
		_this.multipleSelection.forEach(function(e,index) {if(id==e.id) isselect=1});
				
		if(isselect==1) {
			_this.multipleSelection.forEach(function(e,index) {if(id==e.id) _this.multipleSelection.splice(index,1)});
		}else {	
			_this.multipleSelection.push(row);
												
			//异步判断添加的商品是否满足添加的要求（判断商品库存）
			var resource = _this.$resource(_this.url);
			resource.save({act:'checkinventorys',product:row,token:this.$cookies.get('token')}).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') _this.$router.push('/login');
					_this.$message.error(res.data.Message);
				}else{
				    var data=Base64.decode(res.data.Data);
				    if(data==2) { //库存不足时提示欠货处理
				    	_this.$confirm(row.name+'库存不足，出库时将作为欠货商品处理，您是否要添加该商品', '提示', { type: 'warning' }).then(() => {
				        	//重置信息，添加商品
				        	_this.multipleSelection=[];
    						_this.multipleSelection.push(row);
					    	//添加商品进购物车
					    	_this.addSave();
				        	
						}).catch(() => {
						    //取消操作时，取消勾选的商品
						    _this.$refs.multipleTable.toggleRowSelection(_this.productlists[number]);
						    //勾选的商品列表里剔除该商品
						    _this.multipleSelection.forEach(function(e,index) {if(id==e.id) _this.multipleSelection.splice(index,1)});				       		
						});
					}else { //库存充足时直接添加进购物车
						//重置信息，添加商品
				        _this.multipleSelection=[];
    					_this.multipleSelection.push(row);
					    //添加商品进购物车
					    _this.addSave();
					}
				}
			}).catch((res) => {
				        	
			});
		}
    },
    
    /** 点击每行前面的选择框勾选/取消勾选商品 **/
    handleSelectsingle(val,row) {   
    	this.isopenselect=false; //关闭全选模式
    	var id=row.id;
    	var number=0;
    	var isselect=0;
    	var _this=this;
    	
    	//获取当前商品在商品列表里的位置
    	this.productlists.forEach(function(e,index) {if(id==e.id) number=index});		
		//判断该商品在选取列表里是否存在，存在则删除该商品，不存在则添加该商品
		this.multipleSelection.forEach(function(e,index) {if(id==e.id) isselect=1});
		
    	if(isselect==1) {
			this.multipleSelection.forEach(function(e,index) {if(id==e.id) _this.multipleSelection.splice(index,1)});
		}else {	
			this.multipleSelection.push(row);
							
			//异步判断添加的商品是否满足添加的要求（判断商品库存）
	    	var resource = _this.$resource(_this.url);
	    	resource.save({act:'checkinventorys',product:row,token:this.$cookies.get('token')}).then((res) => {
		    	if(res.data.Result>0){
			    	if(res.data.Result=='70001') this.$router.push('/login');
			        this.$message.error(res.data.Message);
		        }else{
		            var data=Base64.decode(res.data.Data);
		            if(data==2) { //库存不足时提示欠货处理
		            	this.$confirm(row.name+'库存不足，出库时将作为欠货商品处理，您是否要添加该商品', '提示', { type: 'warning' }).then(() => {
		        			//确认添加按原来的方式，此处不做任何处理
				        }).catch(() => {
				       		//取消操作时，取消勾选的商品
				       		this.$refs.multipleTable.toggleRowSelection(this.productlists[number]);
				       		//勾选的商品列表里剔除该商品
				       		this.multipleSelection.forEach(function(e,index) {if(id==e.id) _this.multipleSelection.splice(index,1)});				       		
				        });
		            }
		        }
		    }).catch((res) => {
		        	
		    });
		}
		this.isopenselect=true; //开启全选模式
    },
    
    //商品全选/全不选
    handleSelectall(val) {    	
    	if(this.isopenselect==false) return false; //关闭点击单行添加数据
    	var _this=this;
    	var number=0;
    	var sellect=0;
    	var resource = _this.$resource(_this.url);
    	
    	//已添加有，删除选中信息
    	if(val.length==0) {
    		var ids=[];
    		var selectids=[];
    		this.productlists.forEach(function(e,index) {
    			_this.multipleSelection.forEach(function(ee,i) {
    				if(e.id==ee.id) _this.multipleSelection.splice(i,1);
    			});
    		}); 	
    		return false;
    	}
    	
    	val.forEach(function(e,index) {
    		//异步判断添加的商品是否满足添加的要求（主要判断商品库存）
			resource.save({act:'checkinventorys',product:e,token:_this.$cookies.get('token')}).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') _this.$router.push('/login');
					_this.$message.error(res.data.Message);
				}else{
				    var data=Base64.decode(res.data.Data);
				    if(data==1) {
				    	number=0;sellect=0;	
				    	_this.multipleSelection.forEach(function(ee,ii) {if(ee.id==e.id) {number=ii;sellect=1;}});
				        sellect==0 ? _this.multipleSelection.push(e) : '';
				            	
				    }else if(data==2) {
				    	number=0;sellect=0;
				    	//默认勾选选商品
				    	_this.multipleSelection.forEach(function(ee,ii) {if(ee.id==e.id) {number=ii;sellect=1;}});
					    if(sellect==0) _this.multipleSelection.push(e);
				    		
				        _this.$confirm(e.name+'库存不足，出库时将作为欠货商品处理，您是否要添加该商品', '提示', { type: 'warning' }).then(() => {
					        /**
					        _this.multipleSelection.forEach(function(ee,ii) {
					        	if(ee.id==e.id) {
					        		number=ii;
					        		sellect=1;
					        	}
					        });
				            if(sellect==0) _this.multipleSelection.push(e);
				            */
						        
						}).catch(() => {
							var delselect=0;var delnumber=0;
						    _this.$refs.multipleTable.toggleRowSelection(_this.productlists[index]);
						    _this.multipleSelection.forEach(function(ee,ii) {if(ee.id==e.id) {delnumber=ii;delselect=1;}});
						    if(delselect==1) _this.multipleSelection.splice(delnumber,1);
						});
				    }
				                        
				}
			}).catch((res) => {
				        	
			});
    	});
    },

    
    //匹配勾选的商品信息
    checkselectgoods() {
    	//提取已选中的商品id
    	var _this=this;
    	var ids=[];
    	
    	this.multipleSelection.forEach(function(e,index) {ids.push(e.id)});
    	setTimeout(function() {
    		//已添加的商品默认勾选
    		_this.productlists.forEach(function(e,i) {
	    		ids.forEach(function(ee,ii) {
	    			if(e.id==ee) _this.$refs.multipleTable.toggleRowSelection(_this.productlists[i]);
	    		});
    		});	
    	},100);
    },
    
    
    /** 获取总价 **/
    getTotal(){
        var resource = this.$resource(this.url);
        resource.save({act:'gettotal',derate:this.create.derate,express:this.create.express,carttype:this.query.carttype,token:this.$cookies.get('token')}).then((res) => {
            if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
            }else{
				var pricelist=res.data.Message;
				this.totalprice=pricelist.totalprice; //商品总价
				this.create.total=pricelist.realprice; //商品合计
				this.create.derate=pricelist.derate; //优惠金额
				this.create.express=pricelist.express; //快递费
           	            
            }
        }).catch((res) => {
            //this.$message.error(this.GLOBAL.errortext);
        });
    },
    
    
    /** 获取帐户名称 **/
    getAccountName(id){
		var resource = this.$resource(this.GLOBAL.domain+"Account/index");
	    resource.query({act:'getname',id:id,token:this.$cookies.get('token')}).then((res) => {
	    	if(res.data.Result>0){
	        	if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	            this.accountName=res.data.Message;
	        }
	    }).catch((res) => {
	    	//this.$message.error(this.GLOBAL.errortext);
		});
    },
    
    
    /** 获取销售员名称 **/
    getClerkName(id){
        var resource = this.$resource(this.GLOBAL.domain+"Clerk/index");
        resource.query({act:'getname',id:id,token:this.$cookies.get('token')}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	            this.clerkName=res.data.Message;
	        }
        }).catch((res) => {
            //this.$message.error(this.GLOBAL.errortext);
        });
    },
    
    
    /** 获取顾客名称 **/
    getCustomerName(id){
        if(id!='' && id!=null){
	        var resource = this.$resource(this.GLOBAL.domain+"Customer/index");
	        resource.query({act:'getname',id:id,token:this.$cookies.get('token')}).then((res) => {
	            if(res.data.Result>0){
	            	if(res.data.Result=='70001') this.$router.push('/login')
	            	this.$message.error(res.data.Message);
	            }else{
	            	this.customerName=res.data.Message;
	            }
	        }).catch((res) => {
	            //this.$message.error(this.GLOBAL.errortext);
	        });
        }
    },
    
    
    /** 修改优惠价 **/
    changeDerate(){
    	//检测实付金额是否小于0
    	if(this.create.total < 0) {
    		this.$message.error("应付金额必须大于0");
    		this.create.express=0.00;
    		this.getList();
    		return false;
    	}
    	
    	//检测实付金额是否为自然数
    	if(isNaN(this.create.total)) {
    		this.$message.error("请填写正确的应付金额");
    		this.create.express=0.00;
    		this.getList();
    		return false;
    	}
    
    	//检测实付金额是否小于快递费用
    	if(this.create.total < this.create.express) {
    		this.$message.error("应付金额不能小于快递费用");
    		this.create.express=0.00;
    		this.getList();
    		return false;
    	}
    	
    	//检测实付金额不能大于订单总额减优惠金额
    	/**
    	if((this.create.total-this.create.express) != (this.totalprice-this.create.derate)) {
    		this.$message.error("应付金额-快递费必须等于合计-优惠金额");
    		this.create.express=0.00;
    		this.getList();
    		return false;
    	}
    	*/
    	
    	//优惠金额=订单总价-（应付金额-快递费）    	
        this.create.derate=(this.totalprice-(this.create.total-this.create.express)).toFixed(2);
    },
    
    /** 修改应付金额 **/
    changeDerate1() {
    	//检测优惠金额是否小于0
    	if(this.create.derate < 0) {
    		this.$message.error("优惠金额不能为0");
    		this.create.derate=0.00;
    		this.getList();
    		return false;
    	}
    	
    	//检测优惠金额是否不是数字
    	if(isNaN(this.create.derate)){
	        this.$message.error("请输入正确的优惠金额");
	        this.create.derate=0.00;
    		this.getList();
    		return false;
	    }
    	
    	
    	//检测优惠金额是否大于商品总额
    	/**
    	if(this.create.derate > this.totalprice) {
    		this.$message.error("优惠金额不能大于合计");
    		this.create.derate=0.00;
    		this.getList();
    		return false;
    	}
    	*/
    	//应付金额=订单总价-优惠金额+快递费
    	this.create.total=(parseFloat(this.totalprice-this.create.derate)+parseFloat(this.create.express)).toFixed(2);
    },
    
    /** 修改快递费用 **/
    changeexpress() {
    	//检测输入的价格是否小于0
    	if(this.create.express < 0) {
    		this.$message.error("快递费用不能小于0");
    		this.create.express=0.00;
    		this.getList();
    		return false;
    	}
    	
    	if(isNaN(this.create.express)){
	        this.$message.error("请输入正确的快递费");
	        this.create.express=0.00;
    		this.getList();
    		return false;
	    }
	    
	    //重新计算应收金额
	    this.create.total=(parseFloat(this.totalprice-this.create.derate)+parseFloat(this.create.express)).toFixed(2);
    },
    
    
    /** 新增并且打印 **/
    createPrint(){
    	this.suresellLoading=true;
    	if(this.lists=='') {
    		this.$message.error("请选择需要出库的商品！");
    		this.suresellLoading=false;
    		return false;
    	}
        
        this.create.act="checkprint";
        var resource = this.$resource(this.url);
        resource.query(this.create).then((res) => {
            if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.create.act="add";
	            this.showmsg(res.data.Message);
	            this.suresellLoading=false;
            }else{
		        this.printerDialog=true;
		        var data=JSON.parse(Base64.decode(res.data.Data));
		        this.contactname=data.contactname;
		        this.contactphone=data.contactphone;
		        this.address=data.address;
		        this.getAccountName(this.create.account);
		        this.getClerkName(this.create.seller);
		        this.getCustomerName(this.create.customer);
		        var _this=this;
		        this.sysmanagers.forEach(function(e,index) {
		        	if(_this.create.sysmanager==e.id) _this.sysmanagername=e.truename;
		        });      
		        this.create.act="add";
		        this.suresellLoading=false;
		        
		        //设置打印分页显示信息
          		this.changepage();
            }
        }).catch((res) => {
            //this.$message.error(this.GLOBAL.errortext);
            this.create.act="add";
            this.suresellLoading=false;
        });
    },
    
    
    /** 订单信息打印 **/
    createnoSave(){ 
    	this.printorderLoading=true;  
        var resource = this.$resource(this.url);  
        resource.save({act:'updateprintnumber',token:this.$cookies.get('token'),id:this.printorderdetail.id}).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
                this.printorderLoading=false;  
            }else{             
                this.printlocalpage(); //打印 
            }
        }).catch((res) => {
            this.printorderLoading=false;  
        });
    },
    
    
    /** 撤销订单 **/
    cannelorder(){  
    	this.$confirm('您是否确定将该订单从已审核状态撤销到未审核状态, 是否继续?', '提示', { type: 'warning' }).then(() => {
            // 向请求服务端删除
            this.cannelLoading=true;
	        var resource = this.$resource(this.url);
	        resource.save({act:'cannelorder',token:this.$cookies.get('token'),id:this.printorderdetail.id}).then((res) => {
	            if(res.data.Result>0){
	                if(res.data.Result=='70001') this.$router.push('/login')
	                this.$message.error(res.data.Message);
	                this.cannelLoading=false;
	            }else{
	            	this.$message.success('撤销订单成功！');
	            	this.cannelLoading=false;
					this.printerDialog=false;
					this.getOrderlists();
	            }
	        }).catch((res) => {
	            this.cannelLoading=false;
	        });   
        }).catch(() => {
        	this.$message.info('已取消操作!');
        });
    },
    
    
    /** 打印页面挂单 **/
    finishorder(){
    	this.$confirm('您是否确定完成该订单，将其发货出库, 是否继续?', '提示', { type: 'warning' }).then(() => {
            // 向请求服务端删除
            this.finishLoading=true;
	        var resource = this.$resource(this.url);
	        resource.save({act:'finishorder',token:this.$cookies.get('token'),id:this.printorderdetail.id}).then((res) => {
	            if(res.data.Result>0){
	                if(res.data.Result=='70001') this.$router.push('/login')
	                this.$message.error(res.data.Message);
	                this.finishLoading=false;
	            }else{
	            	this.$message.success('撤销订单成功！');
	            	this.finishLoading=false;
					this.printerDialog=false;
					this.getOrderlists();
	            }
	        }).catch((res) => {
	            this.finishLoading=false;
	        });   
        }).catch(() => {
        	this.$message.info('已取消操作!');
        });
    },
    
    
    /** 打印当前页面 **/
    printlocalpage() {
    	//设置打印完成后回调页面
    	this.$cookies.set('returnurlids','1,7');
    	//设置打印信息
    	var div_print=document.getElementById('printContent');
	    var newStr=div_print.innerHTML;
	    var oldStr=document.body.innerHTML;
	    document.body.innerHTML=newStr;
	    window.print();
	    document.body.innerHTML=oldStr;	    
	    location.reload();
    },
    
    
    /** 自定义错误展示 **/
    showmsg(name) {
    	this.$message({
    		dangerouslyUseHTMLString: true,
    		type:'error',
    		message:'<span style="line-height:20px">'+name+'</span>',
    	});
    },
    
    
    /** 获取产品分类 **/
    getCategoryList() {
    	var resource = this.$resource(this.GLOBAL.domain+"Product/index");
        resource.query({ act:'getcatelist',token:this.$cookies.get('token')}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	            this.categorylist=JSON.parse(Base64.decode(res.data.Data));
	        }
        }).catch((res) => {
            //this.$message.error(this.GLOBAL.errortext);
        });
    },
    
    
    /** 获取打印模板设置 **/
    getprintsmodel() {
    	var resource = this.$resource(this.GLOBAL.domain+"Setting/index");
        resource.query({ act:'getmodelsetting',id:1,token:this.$cookies.get('token')}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	            this.printsmodel=JSON.parse(Base64.decode(res.data.Data));
	            this.rollpage=this.printsmodel.pagevalue < 1 ? 10 : this.printsmodel.pagevalue
	        }
        }).catch((res) => {
            //this.$message.error(this.GLOBAL.errortext);
        });
    },
    
    
    /** 设置分页设置 **/
    changepage() {
    	this.printLoading=true;
    	var number=this.rollpage; //系统设置的每页条数
    	this.prtotal=this.printorderdetail.goods.length; //总条数
    	this.prpage=[];
    	this.prollpage=[];
    	
    	if(number >= this.prtotal) {
    		this.prpage.push({id:1});
    		this.prollpage.push({startpage:0,endpage:number});
    		this.allprintpage=1;
    	}else {
    		var tnumber=parseInt(this.prtotal/number);
    		var lnumber=this.prtotal%number;
    		var index;
    		var start;
    		var end;
    		lnumber > 0 ? tnumber++ : '';
    		this.allprintpage=tnumber;
    		
    		for (var i=0;i<tnumber;i++) {
				index=i+1;
				this.prpage.push({id:index});
				start=i*number;
				end=index*number-1;
				this.prollpage.push({startpage:start,endpage:end});
			}
    	}
    	
    	this.printLoading=false;
    },
    
    
    
    /** 清空购物车里的商品 **/
    delcart() {
    	if(this.showsort==1) {this.$message.error("请先选择终止排序");return false;}
    	this.$confirm('您确定要清空购物车里的商品，继续?', '提示', { type: 'warning' }).then(() => {
        	// 向请求服务端删除
            var resource = this.$resource(this.url);
            resource.save({ act:'delAll',carttype:this.query.carttype,token:this.$cookies.get('token')}).then((res) => {
            	if(res.data.Result>0){
                    if(res.data.Result=='70001') this.$router.push('/login')
                    this.$message.error(res.data.Message);
                }else{
                    this.$message.success('清空购物车商品信息成功!');
                    this.getList();
                    this.getTotal();
                }
            }).catch((res) => {
            	//this.$message.error(this.GLOBAL.errortext);
            });
        }).catch(() => {
            //this.$message.info('已取消操作!');
        });
    },
    
    
    /** 品牌搜索（品牌发生变化时触发一次搜索） **/
    selectbrand() {
    	this.isnewselect=true;
    	this.getProductList();
    },
    /** 分类搜索（分类发生变化触发一次搜索） **/
    selectcate() {
    	this.isnewselect=true;
    	this.getProductList();
    },
    /** 仓库搜索（仓库发生变化触发一次搜索） **/
    selectwarehouse() {
    	this.isnewselect=true;
    	this.getProductList();
    },
    
    
    /** 获取解挂单数量 **/
    getputnumber() {
    	var resource = this.$resource(this.GLOBAL.domain+"Sell/index");
        resource.query({ act:'getputordernumber',token:this.$cookies.get('token')}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	            this.putnumber=Base64.decode(res.data.Data);
	        }
        }).catch((res) => {
            //this.$message.error(this.GLOBAL.errortext);
        });
    },

    
    /** 挂单 **/
    setputorder() {		
		this.$confirm('您是否确定要把当前购物车的商品挂起，继续?', '提示', { type: 'warning' }).then(() => {
    		this.putsave.deliverdate=this.create.deliverdate;
    		this.putsave.account=this.create.account;
    		this.putsave.note=this.create.note;
    		this.putsave.derate=this.create.derate;
    		this.putsave.seller=this.create.seller;
    		this.putsave.customer=this.create.customer;
    		this.putsave.sysmanager=this.create.sysmanager;
    		this.putsave.shipping=this.create.shipping;
    		this.putsave.shippingcode=this.create.shippingcode;
    		this.putsave.express=this.create.express;
    	
        	// 向请求服务端删除
            var resource = this.$resource(this.url);
            resource.save(this.putsave).then((res) => {
            	if(res.data.Result>0){
                    if(res.data.Result=='70001') this.$router.push('/login')
                    this.$message.error(res.data.Message);
                }else{
                    this.$message.success('挂单成功!');                    
                    
                    //重置基础配置信息
                    this.create.deliverdate=new Date().getFullYear().toString() + '-' + (new Date().getMonth()+1) + '-' + new Date().getDate();
		    		this.create.account='';
		    		this.create.note='';
		    		this.create.derate=0.00;
		    		this.create.seller='';
		    		this.create.customer='';
		    		this.search.customer='';
		    		this.create.sysmanager='';
		    		this.create.shipping='';
		    		this.create.shippingcode='';
		    		this.create.express=0.00;
		    		//更新挂单数量
		    		this.getputnumber();
		    		//更新单据单号
		    		this.setDocuments(); 
		    		this.getList(); //更新购物车数据
        			this.getTotal(); //更新总价
					this.getputnumber();//更新挂单数量
                }
            }).catch((res) => {
            	//this.$message.error(this.GLOBAL.errortext);
            });
        }).catch(() => {
            this.$message.info('已取消操作!');
        });
		
    },
    
    
    /** 挂单提交数据 **/
    putorder() {
    	this.$confirm('您是否确定要把当前购物车的商品挂起，继续?', '提示', { type: 'warning' }).then(() => {
    		this.putsave.deliverdate=this.create.deliverdate;
    		this.putsave.account=this.create.account;
    		this.putsave.note=this.create.note;
    		this.putsave.derate=this.create.derate;
    		this.putsave.seller=this.create.seller;
    		this.putsave.customer=this.create.customer;
    		this.putsave.sysmanager=this.create.sysmanager;
    		this.putsave.shipping=this.create.shipping;
    		this.putsave.shippingcode=this.create.shippingcode;
    		this.putsave.express=this.create.express;
    	
        	// 向请求服务端删除
            var resource = this.$resource(this.url);
            resource.save(this.putsave).then((res) => {
            	if(res.data.Result>0){
                    if(res.data.Result=='70001') this.$router.push('/login')
                    this.$message.error(res.data.Message);
                }else{
                    this.$message.success('挂单成功!');                    
                    
		    		//更新出库单号
		    		var result=JSON.parse(Base64.decode(res.data.Data));
		    		this.create.documents=result.documents;
		    		var _this=this;
		    		
		    		//延迟0.5秒打印，防止单据编号没有更新
					setTimeout(function () {
	                    _this.printlocalpage(); //打印
					},500);
		    			
                }
            }).catch((res) => {
            	//this.$message.error(this.GLOBAL.errortext);
            });
        }).catch(() => {
            this.$message.info('已取消操作!');
        });
    },
    
    
    /** 获取解挂列表 **/
    mydownorder() {
        this.putSearch.customer='';
        this.putSearch.key='';
        this.putSearch.date=[];
        this.putSearch.documents='';
    	this.putDialog=true; 
    	this.isputchange=true;   	
    	this.getdownorder();
    },
    
    putchangecustomer() {
    	this.isputchange=true;
    	this.getdownorder();
    },
    
    putchangeseller() {
    	this.isputchange=true;
    	this.getdownorder();
    },
    
    putchangedate() {
    	this.isputchange=true;
    	this.getdownorder();
    },
    putkeychange() {
    	this.isputchange=true;
    	this.getdownorder();
    },
    
    /** 解挂信息列表 **/
    getdownorder() {
    	if(this.isputchange==true) {
    		this.putSearch.p=1;
    		this.putSearch.rollpage=10;
    	}
    	    
    	this.putListLoading=true;
    	var resource = this.$resource(this.GLOBAL.domain+"Sell/index");
        resource.query(this.putSearch).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.putListLoading=false;
	        }else{
	            this.putnumberlists=JSON.parse(Base64.decode(res.data.Data));
	            this.total_put_rows=parseInt(res.data.count);
	            this.putListLoading=false;
	        }
	        
	        if(this.isputchange==true) this.isputchange=false;
        }).catch((res) => {
            //this.$message.error(this.GLOBAL.errortext);
            this.putListLoading=false;
            if(this.isputchange==true) this.isputchange=false;
        });
    },
    putPageSizeChange(val) {
        this.putSearch.rollpage = val;
        this.getdownorder();
    },
    putPageCurrentChange(val) {
        this.putSearch.p = val;
        this.getdownorder();
    },
    
    /** 信息解挂 **/
    delputorder(item) {
    	this.$confirm('您是否确定要对该单子进行解挂，继续?', '提示', { type: 'warning' }).then(() => {    	
        	// 向请求服务端删除
            var resource = this.$resource(this.url);
            resource.save({act:'delputorder',id:item.id,token:this.$cookies.get('token')}).then((res) => {
            	if(res.data.Result>0){
                    if(res.data.Result=='70001') this.$router.push('/login')
                    this.$message.error(res.data.Message);
                }else{                
                    this.$message.success('解挂成功!');
                    var result=JSON.parse(Base64.decode(res.data.Data));
                    
                    //更新订单信息
                    this.create.deliverdate=result.deliverdate;
		    		this.create.account=result.account;
		    		this.create.note=result.note;
		    		this.create.derate=result.derate;
		    		this.create.seller=result.seller;
		    		this.create.customer=result.customer;
		    		this.search.customer=result.customername;
		    		this.create.sysmanager=result.sysmanager;
		    		this.create.shipping=result.shipping;
		    		this.create.shippingcode=result.shippingcode;
		    		this.create.documents=result.documents;
		    		this.create.express=result.express;
		    		
		    		this.getList(); //获取购物车商品信息
		    		this.getTotal();
	                    
	                //更新挂单数量
			    	this.getputnumber();                    
			    	this.putDialog=false;
                }
            }).catch((res) => {
            	//this.$message.error(this.GLOBAL.errortext);
            });
        }).catch(() => {
            this.$message.info('已取消操作!');
        });
    },
    
    
    /** 修改每页条数 **/
    changepagevlaue() {
    	var resource = this.$resource(this.GLOBAL.domain+"Setting/index");
	    resource.query({act:'changepagesize',id:89,num:this.rollpage,token:this.$cookies.get('token')}).then((res) => {
	    	if(res.data.Result>0){
		    	if(res.data.Result=='70001') this.$router.push('/login')
		        this.$message.error(res.data.Message);
	        }else{
	        	this.changepage();
	        }
	    }).catch((res) => {
	        //this.$message.error(this.GLOBAL.errortext);
	    });
    },
    
    
    /** 获取默认发货仓库id **/
    getdefaultwarehouse() {
    	var resource = this.$resource(this.GLOBAL.domain+"Manager/index");
	    resource.query({act:'getdefaultwarehouse',token:this.$cookies.get('token')}).then((res) => {
	    	if(res.data.Result>0){
		    	if(res.data.Result=='70001') this.$router.push('/login')
		        this.$message.error(res.data.Message);
	        }else{
		        var result=JSON.parse(Base64.decode(res.data.Data));
		        this.defaultwarehouseid=result.warehouseid;
	        }
	    }).catch((res) => {
	        //this.$message.error(this.GLOBAL.errortext);
	    });
    },
    
    
    //保存订单信息
    saveorder() {
    	if(this.showsort==1) {this.$message.error("请先选择终止排序");return false;}
    
    	this.suresellLoading=true;
    	this.create.act='saveorder';
    	var resource = this.$resource(this.url);
	    resource.query(this.create).then((res) => {
	    	if(res.data.Result>0){
		    	if(res.data.Result=='70001') this.$router.push('/login')
		        this.$message.error(res.data.Message);
		        this.suresellLoading=false;
	        }else{
		        this.$message.success('保存订单信息成功!');
		        this.suresellLoading=false;
		        this.addandeditsellDialog=false;
		        this.getOrderlists();
	        }
	    }).catch((res) => {
	        //this.$message.error(this.GLOBAL.errortext);
	        this.suresellLoading=false;
	    });
    },
    
    //保存未审核订单
    saveverifyorder() {
    	if(this.showsort==1) {this.$message.error("请先选择终止排序");return false;}
    
    	this.suresellLoading=true;
    	this.create.act='verifyorder';
    	this.create.type='save';
    	var resource = this.$resource(this.url);
	    resource.query(this.create).then((res) => {
	    	if(res.data.Result>0){
		    	if(res.data.Result=='70001') this.$router.push('/login')
		        this.$message.error(res.data.Message);
		        this.suresellLoading=false;
	        }else{
		        this.$message.success('保存订单信息成功!');
		        this.suresellLoading=false;
		        this.addandeditsellDialog=false;
		        this.getOrderlists();
	        }
	    }).catch((res) => {
	        //this.$message.error(this.GLOBAL.errortext);
	        this.suresellLoading=false;
	    });
    },
    
    //确认审核订单
    verifyorder() {
    	if(this.showsort==1) {this.$message.error("请先选择终止排序");return false;}
    
    	this.sellverifyLoading=true;
    	this.create.act='verifyorder';
    	this.create.type='verify';
    	var resource = this.$resource(this.url);
	    resource.query(this.create).then((res) => {
	    	if(res.data.Result>0){
		    	if(res.data.Result=='70001') this.$router.push('/login')
		        this.$message.error(res.data.Message);
		        this.sellverifyLoading=false;
	        }else{
		        this.$message.success('保存订单信息成功!');
		        this.sellverifyLoading=false;
		        this.addandeditsellDialog=false;
		        this.getOrderlists();
	        }
	    }).catch((res) => {
	        //this.$message.error(this.GLOBAL.errortext);
	        this.sellverifyLoading=false;
	    });
    },
    
    //订单确认审核并打印
    verifyorderandprint() {
    	if(this.showsort==1) {this.$message.error("请先选择终止排序");return false;}
    
    	this.sellverifyprintLoading=true;
    	this.create.act='verifyorder';
    	this.create.type='verify';
    	var resource = this.$resource(this.url);
	    resource.query(this.create).then((res) => {
	    	if(res.data.Result>0){
		    	if(res.data.Result=='70001') this.$router.push('/login')
		        this.$message.error(res.data.Message);
		        this.sellverifyprintLoading=false;
	        }else{
		        this.sellverifyprintLoading=false;
		        this.addandeditsellDialog=false;
		        this.getOrderlists(); //更新订单列表
		        
		        var result=JSON.parse(Base64.decode(res.data.Data));
		        //调用打印
		        this.showorder(result);
		        this.$message.success('保存订单信息成功!');
	        }
	    }).catch((res) => {
	        this.sellverifyprintLoading=false;
	    });
    },
    
    //列表删除订单信息
    listsdelorder(item) {
    	this.$confirm('您是否确定删除该未审核的订单，继续?', '提示', { type: 'warning' }).then(() => {    	
            var resource = this.$resource(this.url);
            resource.save({act:'delorder',id:item.id,token:this.$cookies.get('token')}).then((res) => {
				if(res.data.Result>0){
			    	if(res.data.Result=='70001') this.$router.push('/login')
			        this.$message.error(res.data.Message);
		        }else{
			        this.$message.success('删除订单信息成功!');
			        this.getOrderlists();
		        }
            }).catch((res) => {
            	
            });
        }).catch(() => {
            this.$message.info('已取消操作!');
        });
    },
    
    //删除订单信息
    delorder() {
    	this.$confirm('您是否确定删除该未审核的订单，继续?', '提示', { type: 'warning' }).then(() => {    	
	    	this.selldelLoading=true;
	    	this.create.act='delorder';
	    	var resource = this.$resource(this.url);
		    resource.query(this.create).then((res) => {
		    	if(res.data.Result>0){
			    	if(res.data.Result=='70001') this.$router.push('/login')
			        this.$message.error(res.data.Message);
			        this.selldelLoading=false;
		        }else{
			        this.$message.success('删除订单信息成功!');
			        this.selldelLoading=false;
			        this.addandeditsellDialog=false;
			        this.getOrderlists();
		        }
		    }).catch((res) => {
		        //this.$message.error(this.GLOBAL.errortext);
		        this.selldelLoading=false;
		    });
	    }).catch(() => {
            this.$message.info('已取消操作!');
        });
    },
    
    
    //展示打印确认页
    showorder(item) {
    	this.getprintdetail(item.id);
    },
    
    
    //获取订单打印信息
    getprintdetail(id) {
    	this.printerDialog=true;
    	this.printLoading=true;
    	var resource = this.$resource(this.url);
	    resource.save({act:'getprintinfos',token:this.$cookies.get('token'),id:id}).then((res) => {
	    	if(res.data.Result>0){
		    	if(res.data.Result=='70001') this.$router.push('/login')
		        this.$message.error(res.data.Message);
		        this.printLoading=false;
	        }else{
		        this.printorderdetail=JSON.parse(Base64.decode(res.data.Data));
		        //对商品进行分页设置
		        var number=this.rollpage; //系统设置的每页条数
    			this.prtotal=this.printorderdetail.goods.length; //总条数
    			this.prpage=[];
    			this.prollpage=[];
    	
    			if(number >= this.prtotal) {
		    		this.prpage.push({id:1});
		    		this.prollpage.push({startpage:0,endpage:number});
		    		this.allprintpage=1;
    			}else {
		    		var tnumber=parseInt(this.prtotal/number);
		    		var lnumber=this.prtotal%number;
		    		var index;
		    		var start;
		    		var end;
		    		lnumber > 0 ? tnumber++ : '';
		    		this.allprintpage=tnumber;
		    		for (var i=0;i<tnumber;i++) {
						index=i+1;
						this.prpage.push({id:index});
						start=i*number;
						end=index*number-1;
						this.prollpage.push({startpage:start,endpage:end});
					}
		    	}

		        this.printLoading=false;
	        }
	    }).catch((res) => {
	        //this.$message.error(this.GLOBAL.errortext);
	        this.printLoading=false;
	    });
    },
    
    //重置已选中的商品
    cleargoods() {
    	this.multipleSelection=[];
    	//清除勾选的商品信息
    	this.$refs.multipleTable.clearSelection();
    },
    
    //删除已选中的商品里的商品信息
    delmultipleSelection(obj,index) {
    	var id=obj.id;
    	var select=0;
    	var number=0;
    	//查询当前列表里是否选中有该商品，有则取消选择
    	this.productlists.forEach(function(e,i) {if(e.id==id) {select=1;number=i;}});
    	if(select==1) this.$refs.multipleTable.toggleRowSelection(this.productlists[number]);
    	
    	//删除已选中的商品
    	this.multipleSelection.splice(index,1);
    },
    
    
    //商品拖拽排序
    getdata(evt){
    	console.log(evt.draggedContext.element.id);
    },
    datadragEnd(evt){
    	console.log('拖动前的索引：'+evt.oldIndex);
        console.log('拖动后的索引：'+evt.newIndex);                
    },
    
    //启用排序/终止排序
    changegoodsort() {
    	if(this.showsort==0) {
    	    this.showsort=1;
    	    this.showsorttype='danger';
    	    this.showsorticon='el-icon-circle-close-outline';
    	    this.showsortname='终止排序';
    	}else {
    		this.showsort=0;
    	    this.showsorttype='success';
    	    this.showsorticon='el-icon-circle-check-outline';
    	    this.showsortname='启用排序';
			
			var sortcount=this.listsorts.length;
			var lists=[];
			this.listsorts.forEach(function(e,index) {
				lists.push({id:e.id,sort:sortcount});
				sortcount--;
			});
			
			var resource = this.$resource(this.url);
		    resource.save({act:'changesort',token:this.$cookies.get('token'),sorts:lists}).then((res) => {
		    	if(res.data.Result>0){
			    	if(res.data.Result=='70001') this.$router.push('/login')
			        this.$message.error(res.data.Message);
		        }else{			        			
					this.getList();   
		        }
		    }).catch((res) => {
		        //this.$message.error(this.GLOBAL.errortext);
		    }); 	    
    	}
    },
    
    //监听新增/编辑销售出库单
    handleDialogClose() {
    	//有具体的订单信息时直接清空temp里的数据
    	if(this.create.id>0) {
    	    if(this.lists.length==0) {this.addandeditsellDialog=false;return false;}
    		var resource = this.$resource(this.url);
		    resource.query({act:'clearproducts',token:this.$cookies.get('token'),id:this.create.id}).then((res) => {
		    	if(res.data.Result>0){
			    	if(res.data.Result=='70001') this.$router.push('/login')
			        this.$message.error(res.data.Message);			        
		        }else{
			        this.addandeditsellDialog=false; 
		        }
		    }).catch((res) => {
		        this.addandeditsellDialog=false; 
		    });
    		return false;
    	}
    	
    	//新开单需询问用户是否需要删除已添加的商品信息
    	if(this.lists.length > 0) {
	        this.$confirm('温馨提示：您是否需要保留已添加的商品信息?', '提示', { type: 'warning',distinguishCancelAndClose:true,confirmButtonText:'保留',cancelButtonText: '不保留'}).then(() => {
	        	this.addandeditsellDialog=false;    	
		    }).catch(() => {
		    	var resource = this.$resource(this.url);
			    resource.query({act:'clearproducts',token:this.$cookies.get('token')}).then((res) => {
			    	if(res.data.Result>0){
				    	if(res.data.Result=='70001') this.$router.push('/login')
				        this.$message.error(res.data.Message);			        
			        }else{
				        this.addandeditsellDialog=false; 
			        }
			    }).catch((res) => {
			        this.addandeditsellDialog=false; 
			    });
	        });
        }else {
        	this.addandeditsellDialog=false; 
        }
    },

	//切换选择订单出处
	changeordertype(val) {
		this.orderisselect=true;
		this.order.sourceagentid='';
	}
    
  }
}
</script>
<style type="text/css">
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%;overflow:hidden}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
.tabletitle-container {
  width: 100%;
  padding-bottom: 10px;
}

.top1 td {padding-top:2px;font-size:13px}
.top2 td {padding-top:2px;font-size:13px;}
.top1 td span {font-size:13px}
.top2 td span {font-size:13px}
.sureprint {float:right;margin-right:15.5%}
.printsetting {position:fixed;width:100%;height:100%;top:0;left:0;z-index:10000;overflow:hidden;transition:.3s all;background:rgba(0,0,0,0.6)}
.printsetting .printmain {width:20%;height:100%;position:absolute;top:0;right:0;background:#dddddd;border-radius:15px 0 0 15px;border-left:1px solid #dddddd;overflow-y:scroll;box-shadow:-2px 0 20px #000000;transition:.5s all;}
.printsetting .printmain::-webkit-scrollbar {width: 0px;height: 0px;}
.printin {width:90%;height:96%;margin:2% 0 0 5%;background:#dddddd}
.printin .el-form-item__label {font-size:13px}
.contactcontent td {line-height:21px;}
.cctname {overflow:hidden;height:21px;}

.print-sell {width:100%;text-align:right}
.print-sell-page {border-radius:5px;border:1px solid rgb(192, 196, 204);background-color:#fff;color:#606266;width:25px;height:30px;line-height:40px;padding:0 15px;margin-bottom:20px}
.print-sell-page-show {float:right}
.print-sell-page-title {font-size:13px;padding-bottom:2px;margin-bottom:0}
.print-sell-page-table {border-collapse:collapse;font-size:13px;border-color:#333333}


@media print{
  .pageBreak{page-break-after: always;}
  .noPrint{display: none;}
}

#showselectgoods {display:none;position:fixed;width:2%;height:100%;right:0;top:0;background-color:rgba(0,0,0,1);z-index:10000;}
#showselectgoods #selecttitle {width:100%;float:left;color:#fff;text-align:center;font-size:15px;padding:20px 0 20px 0;font-size:15px}
#showselectgoods #selectdata {display:none}
#showselectgoods:hover {width:30%;background-color:#FFF;box-shadow:#000 10px 10px 35px;transition:width 0.5s;}
#showselectgoods:hover #selecttitle {color:#606266;font-size:13px}
#showselectgoods:hover #selectdata {display:block;width:90%;margin-top:20px;margin-left:5%;height:85%;overflow:auto}

/*滚动条样式*/
#selectdata::-webkit-scrollbar {width: 2px;height: 2px;}
#selectdata::-webkit-scrollbar-thumb {border-radius: 15px;-webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);background: rgba(0,0,0,0.2);}
#selectdata::-webkit-scrollbar-track {-webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);border-radius: 0;background: rgba(0,0,0,0.1);}

.sell-type-main {display:flex;justify-content:left;align-items:center;}
.sell-type-icon {width:16px;height:16px;margin-left:10px;overflow:hidden;}
.sell-type-icon img {float:left;width:100%}
</style>


// WEBPACK FOOTER //
// src/components/home/Sell.vue